module.exports = __webpack_public_path__ + "img/56_93.488ab651.png";